<template>
	<Row class="flex-align-center width-100">
		<AppGroupAvatar class="avatar" :group="group" :size="size" />
		<Col class="flex-justify-center">
			<div class="display-flex">
				<h5 class="user-name reg">{{ groupFullName }}</h5>
				<h5 class="description-text reg pl-1">( {{ numOfUsersInGroup }} users )</h5>
			</div>
			<h5 class="description-text reg" v-if="this.groupFullName !== this.groupFullPath">{{ groupFullPath }}</h5>
		</Col>
	</Row>
</template>
<script>
import { mapGettersShorthand } from '@/store/utils/mappers';
import { groups, groupPathItems } from '@/store/modules/accountGroups/getters';

export default {
	name: 'ComboboxGroupItem',
	props: {
		item: { type: Object },
		size: { type: Number, default: 35 },
	},
	computed: {
		...mapGettersShorthand({ groups, groupPathItems }),
		groupId() {
			return this.item.id;
		},
		group() {
			return this.groups.find(({ id }) => id === this.groupId) || this.item.isGroup ? this.item : null;
		},
		groupFullName() {
			return this.group?.name;
		},
		groupFullPath() {
			return this.groupPathNames.join(' > ');
		},
		numOfUsersInGroup() {
			return this.group?.users?.length;
		},
		groupPathNames() {
			return this.groupPathItems(this.group).map((g) => g.name);
		},
	},
};
</script>
<style scoped lang="scss">
.user-name {
	color: var(--primary-font-color);
}
.description-text {
	opacity: 0.5;
	color: #292829;
	font-weight: 300;
}
.avatar {
	margin-right: 10px;
}
</style>
